module.exports = __webpack_public_path__ + "img/alarm-message.8009db68.png";